import styled from '@app/styled';
import { spacing, typography } from '@app/theme';

export const WebhookInputGrid = styled.div`
    display: grid;
    gap: ${spacing(1)};
    width: 100%;
`;

export const WebhookTitle = styled.span`
    ${typography('custom.descriptionMedium')};
`;
